import { useState } from 'react'
import { SelectCompany } from './SelectCompany'
import { SelectPerson } from './SelectPerson'

const SearchPerson = () => {
  const [personRef, setPersonRef] = useState(null)
  const [companyRef, setCompanyRef] = useState(null)
  const [companyDropdownRef, setCompanyDropdownRef] = useState(null)

  return (
    <div className="dFlex w100" style={{ gap: 4 }}>
      <SelectPerson
        companyRef={companyRef}
        onPersonRef={setPersonRef}
        companyDropdownRef={companyDropdownRef}
      />
      <SelectCompany
        personRef={personRef}
        onCompanyRef={setCompanyRef}
        onCompanyDropdownRef={setCompanyDropdownRef}
      />
    </div>
  )
}

export default SearchPerson
